"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.default = {
    root: {
        marginBottom: 42
    },
    [`@media (min-width: ${constants_1.ISOLATE_MAX_WIDTH + constants_1.ISOLATE_X_PADDING * 2}px)`]: {
        root: {
            marginLeft: `calc(50% - ${constants_1.ISOLATE_MAX_WIDTH / 2}px)`
        }
    }
};
//# sourceMappingURL=isolate.header.style.js.map